/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { GetSlotsByDayApiArg, SlotsByDayData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSlotsByDay: build.query<SlotsByDayData, GetSlotsByDayApiArg>({
      query: (queryArg) => ({
        method: 'GET',
        params: {
          date: queryArg.date,
        },
        url: `/v1/slots`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getSlotsByDayApi };
export const { useGetSlotsByDayQuery, useLazyGetSlotsByDayQuery } = injectedRtkApi;
